<template>
<v-touch
  :options="HammerOptions()"
  v-on:pan="handlePan"
  v-on:panend="handlePanEnd"
  v-on:swipeleft="handleSwipeLeft"
  v-on:swiperight="handleSwipeRight"
  :pan-options="{ direction: 'horizontal', threshold: 20 }"
  :swipe-options="{ direction: 'horizontal'}"
  :enabled="draggable && !isSingleSlider"
  :style="{ height }"
>
  <div class="cx-slider --v2"
    dir="ltr"
    :style="{ height }"
    :class="{
      '-full-width': fullWidth,
      '-bar': barPager && numOfItems > 1
    }"
    @mouseenter="mouseEnterHandler"
    @mousedown="mouseDownHandler"
    @mousemove="mouseMoveHandler"
    @mouseup="mouseUpHandler"
    @mouseleave="mouseLeaveHandler"
    @touchstart="touchStartHandler"
    @touchmove="touchMoveHandler"
    @touchend="touchEndHandler"
    @touchcancel="touchCancelHandler"
    @focus="focusHandler"
    @blur="blurHandler"
  >
    <div class="cx-slider__nav" v-if="!isSingleSlider">
      <span v-if="arrowNagv" 
        class="cx-link" @click.prevent="toPrev()">
        <span class="cx-link__icon cx-slider__prev" v-show="hasPrev">
          <i class="far fa-2x fa-chevron-left"></i>
        </span>
      </span>
      <span v-if="arrowNagv" 
        class="cx-link" @click.prevent="toNext()">
        <span class="cx-link__icon cx-slider__next" v-show="hasNext">
          <i class="far fa-2x fa-chevron-right"></i>
        </span>
      </span>
      <div v-show="!hidePager"
        class="cx-slider__pager">
        <template v-for="idx in numOfItems">
          <a :key="idx" class="cx-link"
            :class="{'-active': activeIdx == idx}"
            @click.prevent="toSlide(idx)"
          ></a>
        </template>
      </div>
    </div>
    <div ref="slide" class="cx-slider__slide" 
      :style="{
        height: slideHeight,
        pointerEvents: moveOffset ? 'none' : 'auto',
        overflow: 'hidden'
      }"
    >
     <slot></slot>
    </div>
  </div>  
</v-touch>
</template>

<script>
import Hammer from 'hammerjs';

export default {
  name: 'cx-slider',
  props: {
    barPager: {
      type: Boolean,
      default: false
    },
    cycling: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    timeBreak: {
      type: Number,
      default: 300
    },
    duration: {
      type: Number,
      default: 3000
    },
    height: {
      type: String,
      default: 'auto'
    },
    presetActiveIdx: {
      type: Number,
      default: 1
    },
    arrowNagv: {
      type: Boolean,
      default: false
    },
    hidePager: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isMoving: false,
      isPanning: false,
      items: [],
      activeIdx: 1,
      timer: null,
      resizeTimer: null,
      moveOffset: 0,
      panendcacnelFB: null,
      isFocus: false,
      isMouseEnter: false,
      isSlideItemBusy: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      let idx = parseInt(this.presetActiveIdx, 10) || 1;
      if (idx > this.numOfItems && this.numOfItems > 0) idx = this.numOfItems;
      this.toSlide(idx);
    });
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    this.stopLoop();
    window.removeEventListener('resize', this.resizeHandler);
  },
  computed: {
    slideHeight() {
      return this.barPager && this.height && this.height != 'auto'
        ? `calc(${this.height} - 3rem)`
        : this.height
    },
    numOfItems() {
      return this.items.length;
    },
    isSingleSlider() {
      return this.items.length == 1;
    },
    isLoopOn() {
      return this.cycling && this.loop && !this.isSingleSlider;
    },
    hasNext() {
      return this.cycling || this.activeIdx != this.numOfItems;
    },
    hasPrev() {
      return this.cycling || this.activeIdx != 1;
    }
  },
  methods: {
    slideItemBusy() {
      this.isSlideItemBusy = true;
    },
    slideItemIdle() {
      this.isSlideItemBusy = false;
    },
    HammerOptions() {
      return {
        domEvents: true,
        inputClass: Hammer.TouchMouseInput,
      }
    },
    /**
     * Widnwo event listener
     */
    resizeHandler: function() {
      if (this.resizeTimer != null) {
        clearTimeout(this.resizeTimer);
      } 

      this.resizeTimer = setTimeout(this.reposition, 250);
    },

    /**
     * Slider Event handlers
     */
    mouseEnterHandler: function() {
      console.log('[slider] mouseEnterHandler');
      this.stopLoop();
      this.isMouseEnter = true;
    },

    mouseDownHandler: function() {
      console.log('[slider] mouseDownHandler');
      // start moving
    },

    mouseLeaveHandler: function() {
      console.log('[slider] mouseLeaveHandler');
      this.restartLoop();
      this.isMouseEnter = false;
      // stop moving
    },

    mouseMoveHandler: function() {
      console.log('[slider] mouseMoveHandler');
      // moving
    },

    mouseUpHandler: function() {
      console.log('[slider] mouseUpHandler');
      // stop moving
    },

    touchStartHandler: function() {
      console.log('[slider] touchStartHandler');
      this.stopLoop();
      // start moving
    },

    touchMoveHandler: function(e) {
      if (this.isPanning) {
        e.preventDefault();
        return ;
      }       
      this.isMoving = true;
      console.log('[slider] touchMoveHandler');
      // moving
    },

    touchEndHandler: function() {
      console.log('[slider] touchEndHandler');
      this.restartLoop();
      // stop moving
      this.isMoving = false;
    },

    touchCancelHandler: function() {
      console.log('[slider] touchCancelHandler');
      this.restartLoop();
      // stop moving
      this.isMoving = false;
    },

    focusHandler: function() {
      console.log('[slider] focusHandler');
      this.stopLoop();
      this.isFocus = true;
    },

    blurHandler: function() {
      console.log('[slider] blurHandler');
      this.restartLoop();
      this.isFocus = false;
    },

    /**
     * Looping function
     */
    startLoop: function() {
      if (!this.isLoopOn || this.timer !== null) return;
      this.timer = this.createLoop();
    },
    stopLoop: function() {
      if (this.timer == null) return;
      clearInterval(this.timer);
      this.timer = null;
    },
    restartLoop: function() {
      // Should relase the block before restart
      if (this.isSlideItemBusy) return ;
      this.stopLoop();
      this.startLoop();
    },
    createLoop: function() {
      return setInterval(this.toNext, 3000);
    },



    /**
     *  Update slider item when item mounted
     *  Call by this slider-item in mounted()
     */
    updateItems: function() {
      this.items = (this.$children[0] || {$children: []}).$children
        .filter(child => child.$options.name === 'cx-slider-item');
      this.toSlide(this.activeIdx);
    },


    
    /**
      pan item
     */
    _resetPan: function() {
      this.toSlide(this.activeIdx, this.moveOffset < 0 ? 'R': 'L');
      this.moveOffset = 0;
    },
    handlePan: function(e) {
      // if (this.isMoving && !this.isPanning) return ;

      this.isPanning = true;
      console.log('[slider][hmjs] pan');
      if ((e.center.x == 0 && e.center.y == 0)
        || Math.abs(e.deltaX) > this.$refs.slide.offsetWidth
      ) return ;

      this.moveOffset = e.deltaX;

      this.items.forEach((item, idx) => {
        item.updatePosition({
          idx,
          activeIdx: this.activeIdx,
          toRight: this.moveOffset < 0,
          silence: true,
          cycling: true,
          offset: this.moveOffset
        });
      });
    },

    handlePanEnd: function(e) {
      this.isPanning = false;
      console.log('[slider][hmjs] pan-end');
      // check if swipe happen
      if (e.distance > 10 && Math.abs(e.overallVelocityX) > 0.3) {
        console.log('[slider][hmjs] pan-end: cancel', e.srcEvent.constructor.name);
        this.panendcacnelFB = setTimeout(this._resetPan, 0)
      } else {
        this._resetPan();
      }
    },



    /**
     * Handle swipe
     */
    handleSwipeLeft: function(e) {
      console.log('[slider][hmjs] swipe-left');  
      this.panendcacnelFB && clearTimeout(this.panendcacnelFB)
      if (this.hasNext) {
        this.toNext();
        this.moveOffset = 0;
      } else {
        return this._resetPan();
      }
    },
    handleSwipeRight: function(e) {
      console.log('[slider][hmjs] swipe-right');     
      this.panendcacnelFB && clearTimeout(this.panendcacnelFB);
      if (this.hasPrev) {
        this.toPrev();
        this.moveOffset = 0;
      } else {
        return this._resetPan();
      }
    },



    /**
     * Slide to active index
     */
    _notCyclingSlide: function(activeIdx, silence=false) {
      console.log('[slider][not cycling slide] to', activeIdx, 'silence', silence);
      this.items.forEach((item, idx) => {
        item.updatePosition({
          idx,
          activeIdx,
          silence,
        });
      });
    },

    _cyclingSlide: function(activeIdx, direction='J') {
      /**
       * Set position first
       */
      if (direction == 'J') {
        // figure out direction by activeIdx
        this._notCyclingSlide(this.activeIdx, true);
        setTimeout(() => this._notCyclingSlide(activeIdx), 0);

        return ;
      }

      const toRight = direction == 'R';

      // Re-position for transtion
      this.items.forEach((item, idx) => {
        item.updatePosition({ 
          idx: idx,
          activeIdx: this.activeIdx, 
          toRight,
          silence: true,
          cycling: true,
          offset: this.moveOffset
        })
      });

      // transtion start
      const transtionToRight = (this.moveOffset 
        && activeIdx == this.activeIdx) ? !toRight : toRight;
      setTimeout(((from, to) => () =>  {
        this.items.forEach((item, idx) => {
          item.updatePosition({ 
            idx: idx,
            activeIdx: to, 
            toRight: transtionToRight,
            cycling: true
          })
        })
      })(this.activeIdx, activeIdx), 0);
    },

    toSlide: function(activeIdx, direction='J') {       
      this.slideReposition(); 
      if (!this.cycling) {
        this._notCyclingSlide(activeIdx);
      } else {
        this._cyclingSlide(activeIdx, direction);
      }
      
      // Reset configuration
      this.activeIdx = activeIdx;
      !this.isFocus && this.restartLoop();
      this.$emit('change', activeIdx - 1);
    },

    toNext() {
      if (!this.hasNext) return ;

      let to  = this.activeIdx + 1;
      if (to > this.numOfItems) {
        to = 1;
      }

      this.toSlide(to, 'R');
    },

    toPrev() {
      if (!this.hasPrev) return ;

      let to = this.activeIdx - 1;
      if (to < 1) {
        to = this.numOfItems;
      }

      this.toSlide(to, 'L');
    },

    reposition() {
      console.log('[slider] - reposition active');
      this.items.forEach((item, idx) => {
        item.updatePosition({ 
          idx,
          activeIdx: this.activeIdx,
          silence: true
        })
      });
    },

    slideReposition() {
      if (this.$refs.slide && this.$refs.slide) {
        this.$refs.slide.scrollLeft = 0;
      }
    }

  },
  watch: {
    presetActiveIdx: function() {
      let idx = parseInt(this.presetActiveIdx, 10) || 1;
      if (idx > this.numOfItems && this.numOfItems > 0) idx = this.numOfItems;
      this.toSlide(idx);
    }
  }
}
</script>